import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Check, Close } from '@mui/icons-material';
import { validatePassword, type PasswordRequirement } from '../utils/passwordValidation';

interface PasswordRequirementsProps {
  password: string;
  confirmPassword?: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ 
  password, 
  confirmPassword 
}) => {
  const validation = validatePassword(password, confirmPassword);

  return (
    <Box sx={{ mt: 0.5, mb: 1 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.25, fontSize: '0.775rem' }}>
        Password Requirements:
      </Typography>
      <List dense sx={{ py: 0 }}>
        {validation.requirements.map((requirement: PasswordRequirement, index: number) => (
          <ListItem key={index} sx={{ py: 0.125, px: 0 }}>
            <ListItemIcon sx={{ minWidth: 24 }}>
              {requirement.met ? (
                <Check sx={{ fontSize: 12, color: 'success.main' }} />
              ) : (
                <Close sx={{ fontSize: 12, color: 'error.main' }} />
              )}
            </ListItemIcon>
            <ListItemText 
              primary={requirement.label}
              primaryTypographyProps={{
                variant: 'body2',
                sx: { 
                  color: requirement.met ? 'success.main' : 'error.main',
                  fontSize: '0.75rem',
                  lineHeight: 1.2
                }
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default PasswordRequirements;
